import { Category, V1APIResponse } from "@bullseye/types"

import { useGetRequest } from "./useRequest"

const CATEGORY_EMOJI_BY_TITLE: Record<string, string> = {
  "Social Meetups": "🤝",
  "Arts, Culture & Entertainment": "🎭",
  "Books, Lectures & Learning": "📖",
  "Games, Crafts & Hobbies": "🎲",
  "Health & Wellness": "🌱",
  "Fitness & Movement": "👟",
  "Outdoors & Nature": "🌸",
  "Religion & Spirituality": "🧘",
  "Volunteering & Community Support": "🤲",
  "Coffee, Food & Drink": "☕",
  "Shopping & Local Finds": "🛍️",
  "Special Event": "🎉",
  "New Member Event": "✨",
}

export const getCategoryEmoji = (title: string): string =>
  CATEGORY_EMOJI_BY_TITLE[title] ?? ""

type UseCategoriesArgs = {
  accessToken?: string
}

export const useCategories = (args?: UseCategoriesArgs) => {
  const headers = args?.accessToken
    ? { Authorization: `Bearer ${args.accessToken}` }
    : {}

  const { data, isLoading, error, refetch } = useGetRequest<
    V1APIResponse<Category>
  >(
    {
      method: "GET",
      path: "v1/categories",
      headers,
    },
    {
      enabled: true,
      staleTime: 1000 * 60 * 60,
    },
  )

  return {
    categories: data?.data ?? [],
    isLoading,
    error,
    refetch,
  }
}
